(function ($) {
  'use strict';

  var ContentHide = function (selector, config) {
    this.$el = $(selector);

    if (this.$el.length < 1) {
      return;
    }

    this.height = null;
    this.width = null;
    this.visibleHeight = null;
    this.elementHeight = null;
    this.shown = true;
    this.expanded = false;

    this.viewportHeightRatio =
      config && config.viewportHeightRatio ? config.viewportHeightRatio : 0.6;
    this.hideFrom = config && config.hideFrom ? config.hideFrom : false;
    this.hideTo = config && config.hideTo ? config.hideTo : false;
    this.showMore =
      config && config.showMoreText
        ? config.showMoreText
        : window.ys && window.ys.show_more
          ? window.ys.show_more
          : '+';

    this.$showButton = $(
      "<button class='show-more'>" + this.showMore + '</button>'
    );

    this.setDimensions();
    this.process();

    $(window).on('realResize', this.resize.bind(this));

    this.$el.on(
      'click touchend',
      '.show-more',
      function (e) {
        if (e.originalEvent && !e.originalEvent.cancelable) {
          return;
        }

        this.showElement();
        this.expanded = true;
      }.bind(this)
    );
  };

  ContentHide.prototype.resize = function () {
    this.setDimensions();
    if (this.hideTo || this.hideFrom) {
      this.process();
    }
  };

  ContentHide.prototype.setDimensions = function () {
    this.height = $(window).height();
    this.width = $(window).width();
    this.visibleHeight = this.height * this.viewportHeightRatio;

    this.$el.css('height', 'auto');
    this.elementHeight = this.$el.height();
    if (!this.shown) {
      this.$el.css('height', this.visibleHeight);
    }
  };

  ContentHide.prototype.process = function () {
    if (!this.hideFrom && !this.hideTo) {
      this.hideElement();
      return;
    }

    if (
      (this.hideFrom &&
        this.hideTo &&
        this.hideFrom < this.width &&
        this.hideTo > this.width) ||
      (this.hideFrom && this.hideFrom < this.width) ||
      (this.hideTo && this.hideTo > this.width)
    ) {
      this.hideElement();
      return;
    }

    this.showElement();
  };

  ContentHide.prototype.hideElement = function () {
    if (!this.shown || this.expanded) {
      return;
    }

    if (this.visibleHeight > this.elementHeight) {
      return;
    }

    this.shown = false;

    this.$el.addClass('hidden-content');
    this.$el.animate({
      height: this.visibleHeight,
    });

    this.$el.append(this.$showButton);
    this.$showButton.fadeIn();
  };

  ContentHide.prototype.showElement = function () {
    if (this.shown) {
      return;
    }

    this.shown = true;

    this.$showButton.fadeOut(function () {
      $(this).remove();
    });

    this.$el.removeClass('hidden-content');

    this.$el.animate(
      {
        height: this.elementHeight,
      },
      {
        complete: function () {
          this.$el.css('height', 'auto');
        }.bind(this),
      }
    );
  };

  new ContentHide('.single-format-video main .video-detail > .entry-content', {
    hideTo: 767,
  });
}).bind(window)(jQuery);
